import React, { useMemo } from "react"
import { useSelector } from "react-redux";
import { Grid, Icon } from "semantic-ui-react"
import { Profil } from "../../model/entities/profil";
import { TypeInvestisseur } from "../../model/entities/types-investisseur";
import { AuthenticationState } from "../../model/state/authentication-state";
import { ApplicationState } from "../../store";

interface Props {
}

export function InformationPieceJustifMessage({}: Props) {

    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>((state) => state.authentication);

    const isInvestisseurParticulier = useMemo(() => {
        if(loginProps.user?.ProfilCode === Profil.INVESTISSEUR && !loginProps.user?.Etablissement) {
            return true
        }
        return false
    }, [loginProps])

    return(
        <>
            {isInvestisseurParticulier &&
                <div
                    css={{
                        background: "#BEE4F2",
                        borderRadius: "0.5rem",
                        border: "2px solid #16586F",
                        fontWeight: "bold",
                        padding: "1.3rem",
                        marginBottom: "1.89rem !important",
                    }}
                >
                    <Grid doubling stackable>
                        <Grid.Row columns={2}>
                            <Grid.Column
                                css= {{
                                    marginBottom: "1rem !important",
                                }}
                            >
                                <Icon
                                    css= {{
                                        color: "#16586F",
                                    }}
                                    name="check circle"
                                    size="large"
                                />
                                En cours de validité
                            </Grid.Column>
                            <Grid.Column>
                                <Icon
                                    css= {{
                                        color: "#16586F",
                                    }}
                                    name="check circle"
                                    size="large"
                                />
                                Facilement lisible
                            </Grid.Column>
                            <Grid.Column>
                                <Icon 
                                    css= {{
                                        color: "#16586F",
                                    }}
                                    name="check circle"
                                    size="large"
                                />
                                Avec les bords visibles
                            </Grid.Column>
                            <Grid.Column>
                                <Icon 
                                    css= {{
                                        color: "#16586F",
                                    }}
                                    name="check circle"
                                    size="large"
                                />
                                En couleur
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>    
                </div>
            }
        </>  
    )
}